import React from 'react';
import { Button } from 'react-bootstrap';

function Home({ setActiveSection }) {
    return (
        <div>
            <div
                className="position-relative overflow-hidden p-1 p-md-5 m-md-3 text-center row align-items-center rounded-4"
                style={{
                    backgroundImage: 'url(/background.png)',
                    backgroundSize: 'cover',
                    backgroundRepeat: 'no-repeat',
                    backgroundPosition: 'center',
                    minHeight: '100vh'
                }}
            >
                <div className="col-md-5 p-lg-5 mx-auto my-3 p-4">
                    <img src="logo-vini.png" className="img-fluid " alt="..."></img>


                </div>
                <div className="col-md-5 p-lg-5 mx-auto my-3">
                    <h1 className="display-4 font-weight-normal">Psicologia, Educação e Direitos Humanos</h1>
                </div>

            </div>

            <div className="m-5 projetos-container">
                <p className="fw-bold">Por uma Educação e Psicologia Críticas e Emancipatórias</p>

                <span>O Instituto Pasqualin nasceu do compromisso com a transformação social, reconhecendo a urgência de enfrentar
                    desigualdades, preconceitos e injustiças que estruturam nossas relações sociais e institucionais. Vivemos em um mundo
                    atravessado por sistemas históricos de opressão que perpetuam formas de exclusão. Esses sistemas não apenas moldam a
                    sociedade, mas também se manifestam no cotidiano e nas práticas psicológicas. O Instituto Pasqualin surge como um espaço
                    de resistência, produção de redes e inovação, dedicado a desnaturalizar essas opressões e a promover um pensamento crítico,
                    capaz de articular subjetividades livres, saudáveis e plurais.</span>

                <br></br>
                <hr></hr>
                <br></br>
                <div className="button-container">
                    <Button  className="button-nav" onClick={() => { setActiveSection('Cursos'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>Cursos</Button>
                    <Button  className="button-nav" onClick={() => { setActiveSection('Projetos'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>Projetos</Button>
                    <Button  className="button-nav" onClick={() => { setActiveSection('Atendimento'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>Atendimento</Button>
                    <Button  className="button-nav" onClick={() => { setActiveSection('SupervisaoEscolar'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>Supervisão Escolar</Button>
                    <Button  className="button-nav" onClick={() => { setActiveSection('Grupos'); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>Grupos de Estudos</Button>
                </div>
                <br></br>
                <hr></hr>
                <br></br>
                <p className="fw-bold">O que fazemos</p>
                <ul>
                    <li><strong>Formação crítica:</strong> Oferecemos cursos, oficinas e capacitações que questionam epistemologias coloniais e promovem práticas educacionais e psicológicas inclusivas.</li>
                    <li><strong>Pesquisa engajada:</strong> Desenvolvemos estudos que denunciam desigualdades e oferecem alternativas transformadoras, abordando temas como racismo, gênero, sexualidade, saúde mental e inclusão.</li>
                    <li><strong>Intervenções sociais:</strong> Atuamos em comunidades e escolas, promovendo escuta ativa, acolhimento e práticas participativas que empoderem sujeitos e grupos marginalizados.</li>
                    <li><strong>Consultoria e advocacy:</strong> Apoiamos a formulação e implementação de políticas públicas e educacionais voltadas para a promoção da equidade e dos direitos humanos.</li>
                </ul>


                <br></br>
                <hr></hr>
                <br></br>
                <p className="fw-bold">Nossa Origem</p>

                <span>Fundado em 2023, efeito de uma trajetória de 10 anos, o Instituto Pasqualin surgiu a partir de inquietações frente à
                    perpetuação de desigualdades e do desejo de criar novos espaços de cuidado e pensamento. Desde o início, adotamos um
                    posicionamento contrário à neutralidade, entendendo que a verdadeira transformação exige engajamento ético e político. </span>
                <br>
                </br>
                <span>Nossa trajetória começou com a formação de profissionais das políticas públicas, incentivando práticas emancipatórias
                    e críticas, capazes de questionar as hierarquias e desigualdades que atravessam a vida cotidiana.</span>

                <br></br>
                <hr></hr>
                <br></br>
                <p className="fw-bold">Por que existimos?</p>

                <span>No Brasil, onde desigualdades estruturais são historicamente naturalizadas, acreditamos que nenhuma prática psicológica pode ser neutra ou alienada. É preciso enfrentar as raízes das opressões para construir ambientes verdadeiramente inclusivos. </span>
                <br>
                </br>
                <span>O Instituto Pasqualin propõe uma atuação que desestabiliza discursos hegemônicos e privilegia a pluralidade, valorizando a diversidade de gênero, sexualidade, raça, classe e capacidades. Nosso compromisso é com uma psicologia que promova o desenvolvimento humano em sua integralidade, combatendo preconceitos e construindo alternativas éticas e solidárias.</span>

                <br></br>
                <hr></hr>
                <br></br>
                <p className="fw-bold">Nossos Princípios</p>

                <ol>
                    <li><strong>Compromisso ético-político:</strong> Reconhecemos a responsabilidade social de nossa atuação e seu impacto nas vidas humanas.</li>
                    <li><strong>Ação crítica:</strong> Desafiar práticas normativas e construir alternativas que rompam com as desigualdades estruturais.</li>
                    <li><strong>Pluralidade epistemológica:</strong> Incorporar saberes diversos, especialmente aqueles historicamente marginalizados, na produção de conhecimento.</li>
                    <li><strong>Promoção da justiça social:</strong> Trabalhar pela transformação estrutural da sociedade, priorizando os direitos humanos e a equidade.</li>
                </ol>

                <br></br>
                <hr></hr>
                <br></br>
                <p className="fw-bold">Nosso impacto</p>

                <span>Ao longo de nossa trajetória, impactamos diretamente profissionais da educação, psicólogos, gestores e comunidades.
                    Por meio de nossas formações e intervenções, contribuímos para a construção de práticas que rompem com as hierarquias de
                    poder e abrem caminhos para a criação de espaços mais democráticos e inclusivos.</span>

                <br></br>
                <hr></hr>
                <br></br>
                <p className="fw-bold">Um convite à transformação</p>

                <span>O Instituto Pasqualin é um espaço de compromisso ativo com a mudança. Nossa proposta é desafiar estruturas e criar
                    práticas emancipatórias que promovam o respeito às diversidades e o enfrentamento das desigualdades.</span>
                <br></br>
                <span>Convidamos você a caminhar conosco, questionando práticas, reinventando compromissos e, sobretudo, acreditando que
                    outro mundo é possível – um mundo onde a psicologia e a educação sejam ferramentas para a justiça, a equidade e a
                    transformação social.</span>
                <br></br>
                <br></br>
                <span>Estamos aqui para pensar, construir e transformar juntos.</span>
            </div>
        </div>

    );
}

export default Home;
